import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
// import InputLabel from '@material-ui/core/InputLabel';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  inputLabel: {
    display: 'inline'
  },
  input: {
    display: 'none'
  },
  image: {
    width: '100%',
    margin: '5px',
    maxWidth: 300
  }
};

const enhance = compose();

const Main = enhance(({ classes, previewImage }) => {
  return (
    <div>
      <Card className={classes.image}>
        <CardActionArea>
          <CardMedia component="img" image={previewImage} />
        </CardActionArea>
      </Card>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
